import { CalculatorStyles } from './Calculator.types'

const makeStyles = (): CalculatorStyles => ({
	container: {
		backgroundColor: '#FFF0BA',
		fontFamily: 'SVFont',
		fontSize: '27px',
		padding: '0px 10px'
	}
})

export default makeStyles
